import { getFocusableElements } from '../Shared/focusable';

const DESKTOP_BREAKPOINT = 991;
const DESKTOP_MENU_WIDTH = '750px';

const mobMenu = document.getElementById('mobMenu');
const mobileModal = document.querySelector<HTMLElement>('.mobileModal');
const backdrop = document.querySelector<HTMLElement>('.mobile-menu-backdrop');
const header = document.querySelector<HTMLElement>('header');
const body = document.body;

let openerButton: HTMLElement | null = null;
let initialNavHTML: string | null = null;

function trapFocus(e: KeyboardEvent): void {
    const focusable = getFocusableElements(mobMenu);
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.key === 'Tab') {
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }

    if (e.key === 'Escape') {
        closeMenu();
    }
}

function setMobileMenuPosition(): void {
    const headerHeight = header?.offsetHeight ?? 0;
    const sidenavEl = document.querySelector<HTMLElement>('.sidenav');

    if (mobMenu) mobMenu.style.top = `${headerHeight}px`;
    if (backdrop) backdrop.style.top = `${headerHeight}px`;

    if (window.innerWidth > DESKTOP_BREAKPOINT) {
        if (sidenavEl) sidenavEl.style.height = `calc(100% - ${headerHeight}px)`;
    } else {
        if (sidenavEl) sidenavEl.style.height = '';
        if (mobMenu) mobMenu.style.top = '0px';
    }
}

function applyPositionWithoutTransition(): void {
    if (!mobMenu) return;
    mobMenu.style.transition = 'none';
    setMobileMenuPosition();
    mobMenu.offsetHeight; // force reflow
    mobMenu.style.transition = '';
}

function setMenuOpen(button: HTMLElement | null, open: boolean): void {
    button?.setAttribute('aria-expanded', String(open));
    mobMenu?.setAttribute('aria-hidden', String(!open));
}

function openMenu(button: HTMLElement | null, width: string): void {
    openerButton = button;
    mobMenu?.classList.add('open');
    if (mobMenu) mobMenu.style.width = width;
    if (header) header.style.height = '100%';
    if (mobileModal) mobileModal.style.display = 'block';
    body.style.overflow = 'hidden';
    setMenuOpen(button, true);
    document.addEventListener('keydown', trapFocus);
    // defer focus so the menu is visible before focusing
    requestAnimationFrame(() => getFocusableElements(mobMenu)[0]?.focus());
}

function closeMenu(): void {
    mobMenu?.classList.remove('open');
    if (mobMenu) mobMenu.style.width = '0';
    if (mobileModal) mobileModal.style.display = 'none';
    if (header) header.style.height = 'initial';
    body.style.overflow = 'auto';
    setMenuOpen(openerButton, false);
    document.removeEventListener('keydown', trapFocus);
    openerButton?.focus();
    openerButton = null;

    const navList = document.querySelector<HTMLElement>('ul.mobMenu.mobileNavigation');
    if (navList && initialNavHTML !== null) {
        navList.innerHTML = initialNavHTML;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const navList = document.querySelector<HTMLElement>('ul.mobMenu.mobileNavigation');
    if (navList) initialNavHTML = navList.innerHTML;

    const mobileBtn = document.getElementById('mobileNavCtrl');
    const desktopBtn = document.getElementById('mobileNavCtrlDesktop');

    mobileBtn?.addEventListener('click', () => {
        applyPositionWithoutTransition();
        openMenu(mobileBtn, '100%');
    });

    desktopBtn?.addEventListener('click', () => {
        applyPositionWithoutTransition();

        if (mobMenu?.classList.contains('open')) {
            closeMenu();
        } else {
            openMenu(desktopBtn, DESKTOP_MENU_WIDTH);
        }
    });

    mobMenu?.querySelector('.closebtn')?.addEventListener('click', () => closeMenu());
    mobileModal?.addEventListener('click', () => closeMenu());
    backdrop?.addEventListener('click', () => closeMenu());
});
